import * as React from 'react';
import { AgGridReact } from 'ag-grid-react';
import ReeferStatus from '../routecomponents/ReeferStatus';
import Formatters from '../../actions/Formatters';
import ReeferFormatters from '../../actions/ReeferFormatter';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';

import VesselStatus from '../routecomponents/VesselStatus';
import ReeferDetails from '../routecomponents/ReeferDetails';
import RcdStatus from '../routecomponents/RcdStatus';
import { ReeferStatusGrid } from '../childcomponents/ReeferStatusGrid';
import { ReeferStatusSSRMGrid } from '../childcomponents/ReeferStatusSSRMGrid';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import { GridToolBarPopups } from '../sharedcomponents/GridToolBarPopups';
// pull in the ag-grid styles we're interested in
import '../../../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/dist/styles/ag-theme-fresh.css';
import 'react-datepicker/dist/react-datepicker.css';
import { ReeferCellRenderer } from '../../actions/ReeferCellRenderer';
var Config: any = require('../../Config.json');


interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface ReeferCommandsGridState {
    rowData: server.USP_UnitCurrentConditionUI_Model[];
    columnDefs: any[];
    Filters: ForwardCommandParams;
    TraditionalDownload: server.TraditionalDownload;
    overlayLoadingTemplate: any;
    pageSize: any;
    gridApiParams: any;
    VCCheckBoxInfo: VCCheckBoxData;
    GridToolBarHtml: any;
    OtherValue: any;
}

var colDefs;
var self;


export class ReeferCommandsGrid extends React.Component<any, ReeferCommandsGridState> {
    constructor(props: any) {
        super(props);
        var filterSet = new ForwardCommandParams();
        var overlayTemplate = '<span class="ag-overlay-loading-center">Loading...</span>';
        this.state = {
            rowData: [], columnDefs: [], Filters: filterSet, TraditionalDownload: null,
            overlayLoadingTemplate: overlayTemplate, pageSize: 25, gridApiParams: [],
            VCCheckBoxInfo: emptyVCCheckBoxData, GridToolBarHtml: '', OtherValue: null
        };

        self = this;
    }

    static submitTemperatureCommands(commandName, paramValue, refreshGrid) {
        if (self.state.rowData.length > 0) {
            var selectedData = self.state.VCCheckBoxInfo.selectedVCData;
            if (self.state.VCCheckBoxInfo.enableVCCheckBox == true && (selectedData == null || selectedData.VesselId == 0)) { PopupWindow.showErrorMessage("Alert", "Please select vessel name"); }
            else {
                $('#globalLoader').show();
                self.state.Filters.CommandName = commandName;
                self.state.Filters.SelectedReefers = self.state.rowData;
                self.state.Filters.TempValue = paramValue;
                self.state.Filters.IsCmdSendViaVC = self.state.VCCheckBoxInfo.enableVCCheckBox;
                self.state.Filters.VesselInfo = self.state.VCCheckBoxInfo.selectedVCData;
                var forwardCommandParams = JSON.stringify(self.state.Filters);

                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/PostForwardCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<ValidationSeverityResult>)
                    .then(data => {
                        if (data != null && data != undefined) {
                            if (data.Result != null && data.Result != undefined && data.Result.length > 0) {
                                PopupWindow.showErrorMessage("Error", data.Result);
                                $(".mm-popup__box__body").css("white-space", "pre-line");
                                $('#globalLoader').hide();
                                return;
                            }
                        }

                        if ($('#confirmPopUpModel') != undefined) {
                            $("#confirmPopUpModel .btn-close").click();
                            $("#contextMenuModel .btn-close").click();
                        }

                        $("#contextMenuModel .btn-close").click();

                        if (refreshGrid == "details")
                            ReeferDetails.refreshReeferDetailsData();
                        else if (refreshGrid == "home") {
                            if (JSON.parse(sessionStorage.getItem('SSRM'))) {
                                ReeferStatusSSRMGrid.refreshDashboardGrid();
                            }
                            else {
                                ReeferStatusGrid.refreshDashboardGrid();
                            }
                        }
                        else if (refreshGrid == "vessel")
                            VesselStatus.refreshVesselStatusGrid();
                        else if (refreshGrid == "Devicestatus")
                            RcdStatus.refreshDeviceStatusGrid();
                        else
                            ReeferStatus.refreshReeferStatusGrid();
                    });
            }
        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");       
    }

    static submitCommands(commandName, paramValue, refreshGrid) {
        if (self.state.rowData.length > 0) {
            $('#globalLoader').show();
            self.state.Filters.CommandName = commandName;
            self.state.Filters.SelectedReefers = self.state.rowData;
            self.state.Filters.TraditionalDownload = paramValue;
            var forwardCommandParams = JSON.stringify(self.state.Filters);
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/PostForwardCommands', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<ValidationSeverityResult>)
                .then(data => {
                    if (data != null && data != undefined) {
                        if (data.Result != null && data.Result != undefined && data.Result.length > 0) {
                            PopupWindow.showErrorMessage("Error", data.Result);                             
                            $(".mm-popup__box__body").css("white-space", "pre-line");
                            $('#globalLoader').hide();
                            return;
                        }
                    }
                    $("#contextMenuModel .btn-close").click();
                    if (refreshGrid == "details")
                        ReeferDetails.refreshReeferDetailsData();
                    else if (refreshGrid == "home") {
                        if (JSON.parse(sessionStorage.getItem('SSRM'))) {
                            ReeferStatusSSRMGrid.refreshDashboardGrid();
                        }
                        else {
                            ReeferStatusGrid.refreshDashboardGrid();
                        }
                    }
                    else if (refreshGrid == "vessel")
                        VesselStatus.refreshVesselStatusGrid();
                    else
                        ReeferStatus.refreshReeferStatusGrid();
                });

        }
        else
            PopupWindow.showErrorMessage("Alert", "No assets selected");
    }

    componentWillReceiveProps(nextprops: any) {       
        var changeReportingIntervalAction = nextprops.changeReportingIntervalAction;
        var ChangeO2andCo2Action = nextprops.ChangeO2andCo2Action;
        var changeAssetConfigAction = nextprops.assetConfigAction;
        var GetFreshAirType = nextprops.GetFreshAirType;
        var autoConfig = nextprops.autoConfig;
        if (changeReportingIntervalAction == true) {
            colDefs = this.createColumnDefsForCRI();
        }
        else if (ChangeO2andCo2Action == true) {
            colDefs = this.createColumnDefsForO2andCo2();
        }
        else if (changeAssetConfigAction == true) {
            colDefs = this.createColumnDefsForAssetConfig();
        }
        else if (GetFreshAirType == true) {
            colDefs = this.createColumnDefsForGetFreshAirType();
        }
        else {
            colDefs = this.createColumnDefs(autoConfig);
        }

        var reeferData = nextprops.selectedReefers;
        if (reeferData != undefined && reeferData != null) {
            this.setState({ rowData: reeferData }, () => this.renderGridToolBar());
        }

        if (nextprops.VCCheckBoxInfo != undefined && nextprops.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: nextprops.VCCheckBoxInfo });
        }
    }

    renderGridToolBar() {
        this.setState({ GridToolBarHtml: this.renderGridToolBarHtml() });
    }

    renderGridToolBarHtml() {
        return <GridToolBarPopups refreshGrid={this.refreshGrid.bind(this)} gridData={this.state.rowData} colDefs={colDefs} parentchild={"P"} formName={"ReeferCommands"} VCCheckBoxInfo={this.state.VCCheckBoxInfo} UpdateVCCheckBoxInfo={this.UpdateVCCheckBoxInfo.bind(this)} />;
    }

    componentDidMount() {        
        var changeReportingIntervalAction = this.props.changeReportingIntervalAction;
        var ChangeO2andCo2Action = this.props.ChangeO2andCo2Action;
        var changeAssetConfigAction = this.props.assetConfigAction;
        var GetFreshAirType = this.props.GetFreshAirType;
        var autoConfig = this.props.autoConfig;
        if (changeReportingIntervalAction == true) {
            colDefs = this.createColumnDefsForCRI();
        }
        else if (ChangeO2andCo2Action == true) {
            colDefs = this.createColumnDefsForO2andCo2();
        }
        else if (changeAssetConfigAction == true) {
            colDefs = this.createColumnDefsForAssetConfig();
        }
        else if (GetFreshAirType == true) {
            colDefs = this.createColumnDefsForGetFreshAirType();
        }
        else {
            colDefs = this.createColumnDefs(autoConfig);
        }

       
       
        
        

        if (this.props.formName != null && this.props.formName != undefined && this.props.formName != '') {
            if (this.props.formName == 'MultipleSetPoints') {
                var containerHeight = $('.containerstyle_commands').height();
                $('.containerstyle_commands').height(containerHeight - 100);
            }
        } 

        if (this.props.VCCheckBoxInfo != undefined && this.props.VCCheckBoxInfo != null) {
            this.setState({ VCCheckBoxInfo: this.props.VCCheckBoxInfo });
        }
    }

    onGridReady(params: any) {
        params.api.gridOptionsWrapper.gridOptions.suppressContextMenu = true;
        self.setState({ gridApiParams: params.api });
    }

    //removeIndicator(params: any) {
    //    var element = document.createElement("span");
    //    element.className = "reefer-delete";

    //    var imageElement = document.createElement("img");
    //    imageElement.src = deletepng;
    //    imageElement.title = "Remove";

    //    imageElement.onclick = function DeleteCommands() {
    //        params.api.gridOptionsWrapper.gridOptions.rowData.splice(params.rowIndex, 1);
    //        params.api.setRowData(params.api.gridOptionsWrapper.gridOptions.rowData);
    //    }

    //    element.appendChild(imageElement);

    //    return element;
    //}

    refreshGrid = () => {
        /* if (this.props.From == "Device") {
            var selectedRcds = "";
            if (this.state.rowData.length > 0) {
                $('#globalLoader').show();
                $.each(this.state.rowData, function (selectedIndex, selectedValue) {
                    if (selectedValue.RCDID != null) {
                        selectedRcds = selectedRcds == "" ? selectedValue.RCDID : selectedRcds + "," + selectedValue.RCDID;
                    }
                });
                var rcdSearchFilters: server.RcdStatusSearchFilters = { SelectedRcd: selectedRcds, SelectedCountry: null, SelectedInterval: null, SelectedGeofenceInside: null, SelectedGeofence: null, SelectedICCID: null, SelectedMSISDN: null, AllRcds: null, SelectedAssetType: null };

                var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/RcdStatus/RcdStatusSearchDataSP', { method: 'POST', body: JSON.stringify(rcdSearchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                fetch(request)
                    .then(RCUtils.handleError)
                    .then(response => response.json() as Promise<server.USP_RcdCurrentConditionUI[]>)
                    .then(data => {
                        this.setState({ rowData: data }, () => this.renderGridToolBar());
                        $('#globalLoader').hide();
                    });
            }
        }
        else { } */
        var selectedReefers = "";
        if (this.state.rowData.length > 0) {
            $('#globalLoader').show();
            $.each(this.state.rowData, function (selectedIndex, selectedValue) {
                if (selectedValue.ReeferID != null) {
                    selectedReefers = selectedReefers == "" ? selectedValue.ReeferID : selectedReefers + "," + selectedValue.ReeferID;
                }
            });
            var reeferSearchFilters: server.ReeferSearchFilters = {
                SelectedOem: '', SelectedCountry: '', SelectedReefer: selectedReefers, SelectedGeofence: '', SelectedInterval: '', SelectedGeofenceInside: '', SelectedVesselCode: '', StatusFilters: [], AllReefers: '',
                CustomAttributeFilters: null, SelectedAssetTypes: '', SelectedAssetStates: '', SelectedBookingNumber: '', SelectedVesselCD: '', SelectedCall: '', SelectedVoyage: '',
                SelectedCargoCareProfiles: '', SelectedPod: '', SelectedPol: '', SelectedCTProfileIds: []  //WI-26881
             };

            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/ReeferStatusDataSP', { method: 'POST', body: JSON.stringify(reeferSearchFilters), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
                .then(data => {
                    this.setState({
                        rowData: data
                    }, () => {
                        this.renderGridToolBar();
                        var filters: server.ForwardCommandParameters = {
                            SelectedReefers: data, CommandName: this.props.commandName, TempValue: "", OtherValue: self.state.OtherValue, IsCmdSendViaVC: null, VesselInfo: null
                        };
                        var forwardCommandParams = JSON.stringify(filters);
                        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetForwardCommandData', { method: 'POST', body: forwardCommandParams, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                        fetch(request)
                            .then(RCUtils.handleError)
                            .then(response => response.json() as Promise<server.USP_UnitCurrentConditionUI_Model[]>)
                            .then(data => {
                                this.setState({ rowData: data }, () => this.renderGridToolBar());
                                $('#globalLoader').hide();

                            });
                    });
                });
        }

        self.state.gridApiParams.paginationGoToFirstPage();
        
    };

    reeferTypeFormatter(params: any) {
        if (params.data.UnitTypeCd != null && params.data.UnitTypeCd != "") {
            var reeferType = this.props.reeferFormatter.UnitTypesList.filter(e => e.UnitTypeCd === params.data.UnitTypeCd);
            return reeferType[0].Description.toString();
        }
    }    
    
    UpdateVCCheckBoxInfo(VCInfo: any) {
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(VCInfo);
    }

    static UpdateOtherValue(value: any) {
        self.setState({ OtherValue: value });
    }
    //26724 - added missing parameter
    createColumnDefsForAssetConfig() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "Device config", field: "DeviceConfig", cellRenderer: Formatters.GuestReeferModeFormatter, width: 120 },
            { headerName: "Device type", field: "DeviceType", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 120 },
            { headerName: "Reefer type", field: "UnitTypeCd", cellRenderer: ReeferCellRenderer.StringTypeFormatter, valueGetter: (params) => { return this.reeferTypeFormatter(params); }, width: 150 },
            { headerName: "T set", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            {
                headerName: "Last event", field: "EventDescription",
                cellRenderer: (params) => {
                    return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList,
                        self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts);
                }, width: 150
            },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Assigned to", field: "CustomerName", cellRenderer: ReeferCellRenderer.StringTypeFormatterFor3P, width: 130 }
        ];
    }
    //26724 - added missing parameter
    createColumnDefs(autoConfig: any) {
        if (autoConfig)
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "T set ", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "RH set", field: "HumiditySetpoint", cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 90 },
            { headerName: "Last event", field: "LastEvent", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 150 },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "R_EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 150 },
            ];
        else
            return [
                { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
                { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
                { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
                { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
                { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
                { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
                { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
                { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
                { headerName: "T set ", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
                { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
                { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
                { headerName: "RH set", field: "HumiditySetpoint", cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 90 },
                {
                    headerName: "Last event", field: "EventDescription",
                    cellRenderer: (params) => {
                        return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList,
                            self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts);
                    }, width: 150
                },
                { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
                { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 150 },
            ];
    }
    //26724 - added missing parameter
    createColumnDefsForCRI() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "T set", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "RH set", field: "HumiditySetpoint", cellRenderer: ReeferFormatters.HumiditySetpointFormatter, width: 90 },
            {
                headerName: "Last event", field: "EventDescription",
                cellRenderer: (params) => {
                    return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList,
                        self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts
                    );
                }, width: 150
            },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 150 },
            { headerName: "Reporting (min)", field: "RCDReportingInterval", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 }
        ];
    }
    //26724 - added missing parameter
    createColumnDefsForO2andCo2() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "CO2 set ", field: "CO2Setpoint", width: 90, cellRenderer: Formatters.sensorDataFormatter },
            { headerName: "O2 set ", field: "O2Setpoint", width: 90, cellRenderer: Formatters.sensorDataFormatter },
            { headerName: "T set ", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            {
                headerName: "Last event", field: "EventDescription",
                cellRenderer: (params) => {
                    return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList,
                        self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts);
                }, width: 150
            },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 150 },
        ];
    }
    //26724 - added missing parameter
    createColumnDefsForGetFreshAirType() {
        return [
            { headerName: "Remove", field: "ReeferID", width: 85, cellRenderer: ReeferCellRenderer.removeIndicator },
            { headerName: "State", field: "IsPending", width: 80, cellRenderer: ReeferCellRenderer.CommandValidator, tooltipField: "Tooltip" },
            { headerName: "CC", field: "CCSeverityLevel", width: 65, valueGetter: (params) => { return ReeferFormatters.CargoCareSorting(params); }, cellRenderer: ReeferCellRenderer.CargoCareFormatter },
            { headerName: "ALM", field: "MASeverityLevel", width: 65, cellRenderer: ReeferCellRenderer.statusIndicatorforALM },
            { headerName: "RUN", field: "RunState", width: 65, cellRenderer: ReeferCellRenderer.RunStateFormatter },
            { headerName: "VSL", field: "VesselCd", width: 80, cellRenderer: ReeferCellRenderer.StringTypeFormatter },
            { headerName: "OEM", field: "ReeferOEMTypeCd", cellRenderer: Formatters.oemTypeFormatter, width: 70 },
            { headerName: "Reefer ID", field: "ReeferID", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 140 },
            { headerName: "Fresh air type", field: "FreshAirType", cellRenderer: ReeferCellRenderer.StringTypeFormatter, width: 130 },
            { headerName: "T set ", field: "SetPoint", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T sup 1 ", field: "SupplyTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            { headerName: "T rtn 1 ", field: "ReturnTemp1", width: 90, cellRenderer: Formatters.TemperatureFormatter, headerValueGetter: Formatters.TempHeaderFormatter },
            {
                headerName: "Last event", field: "EventDescription",
                cellRenderer: (params) => {
                    return ReeferFormatters.EventDescriptionFormatters(params, self.props.reeferFormatter.CustomerSpecificEventList,
                        self.props.reeferFormatter.EventMasterList, self.props.reeferFormatter.M_CustomerAssetTypeDeviceTypeSensorAlerts, self.props.reeferFormatter.Ref_SensorAlerts);
                }, width: 150
            },
            { headerName: "Event time", headerValueGetter: Formatters.TimeZoneHeaderFormatter, field: "EventDTTM", cellRenderer: Formatters.dateTypeFormatter, width: 150 },
            { headerName: "Alarm", field: "AlarmsList", cellRenderer: ReeferCellRenderer.AlarmListFormatter, width: 150 },
        ];
    }

    pageSizeChange(event: React.FormEvent<HTMLSelectElement>) {
        var pageSize = this.state.pageSize;
        var Value: string = event.currentTarget.value;
        pageSize = Value;

        self.setState({
            pageSize: pageSize
        });

        self.state.gridApiParams.paginationSetPageSize(parseInt(pageSize));
        self.state.gridApiParams.paginationGoToFirstPage();
        //alert(this.state.pageSize);
    }

    public render() {
        return <div>
            <div>
                {this.state.GridToolBarHtml}                
            </div>
            <div className="ag-theme-fresh containerstyle_commands">
                <AgGridReact
                    columnDefs={colDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                    pagination={true}
                    accentedSort={true}
                    paginationPageSize={this.state.pageSize}
                    overlayLoadingTemplate={this.state.overlayLoadingTemplate}>
                </AgGridReact>
            </div>
            <div className='pageSize'>
                <span className='pageSize-lable'>Page Size:</span>
                <select onChange={e => this.pageSizeChange(e)} value={this.state.pageSize}>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="75">75</option>
                    <option value="100">100</option>
                    <option value="250">250</option>
                </select>
            </div>
        </div>
    }
}

class ForwardCommandParams {
    SelectedReefers: server.USP_UnitCurrentConditionUI_Model[];
    CommandName: string;
    TempValue: any;
    TraditionalDownload: server.TraditionalDownload;
    IsCmdSendViaVC?: Boolean
    VesselInfo: server.VesselInformation; 
}
class ValidationSeverityResult {
    Serverity: string;
    Result: string;
}